import PropTypes from 'prop-types';
import { Component } from 'react';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import WebhookActionMetadata from 'automation-ui-action-features/actions/webhook/records/WebhookActionMetadata';
import WebhookActionDetail from 'automation-ui-action-features/actions/webhook/WebhookActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class WebhookActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(WebhookActionDetail, {
        actionMetadata: actionMetadata
      })
    });
  }
}
WebhookActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(WebhookActionMetadata).isRequired,
  actionLabel: PropTypes.node
};
export default WebhookActionHistoryCard;